<template>
  <Layout
    @componentKey="gotRefresh"
    @currentPage="currentPage"
    :hasPagination="true"
    :hasBreadcrumbs="true"
    :amount="amount.aantal"
    :amountToShow="amountToShow"
    :openModalHandler="openModalHandler"
  >
    <div class="content">
      <div class="page-content" ref="tableContent">
        <MainTitle :title="this.$router.currentRoute.name" />
        <DhrTable
          @selectedAmount="gotAmountToShow"
          @selectedRow="gotDHR"
          :DHRecords="DHRecords"
          :totalItems="amount.aantal"
          @sorting="gotSorting"
          @refresh="gotRefresh"
          :isEditable="true"
          dateLabel="Approval date"
        />
      </div>
      <div class="sidebar">
        <TableAction
          v-bind:hasButton="false"
          @clickedButton="gotClick"
          title="Add Raw Material"
          :isAdd="true"
        />
        <TableDetail
          v-if="this.selectedDHR"
          height="44"
          :details="this.selectedDHR"
          dateLabel="Startdate"
        />
        <TblDetailQRcode
          v-if="this.selectedDHR"
          :details="this.selectedDHR"
          @refresh="gotRefresh"
        />
      </div>
    </div>
  </Layout>
</template>
<script>
// @ is an alias to /src
import Layout from "@/layouts/Dashboard";
import DhrTable from "@/components/TblDHR";
import TableAction from "@/components/TableAction";
import TableDetail from "@/components/TblDHRDetail";
import TblDetailQRcode from "@/components/TblDetailQRcode";
import MainTitle from "@/components/base/MainTitle";

export default {
  name: "production-inProgress",
  props: {
    compKey: Number,
  },
  data() {
    return {
      DHRecords: [],
      amount: 0,
      selectedDHR: null,
      pagina: 1,
      openModalHandler: false,
      sortingOn: "ref",
      isAscending: true,
      amountToShow: 8,
    };
  },
  components: {
    Layout,
    DhrTable,
    MainTitle,
    TableAction,
    TableDetail,
    TblDetailQRcode,
  },
  computed: {
    maxRows: function () {
      let heightContent = this.$refs.tableContent.clientHeight;
      let heightSingleRow = 76;

      return Math.ceil(heightContent / heightSingleRow) - 2;
    },
  },
  mounted() {
    this.amountToShow = this.maxRows;
    this.getData();
  },
  methods: {
    gotAmountToShow(val) {
      if (val == 9) {
        this.amountToShow = this.maxRows;
      } else {
        this.amountToShow = parseInt(val);
      }
      this.pagina = Math.ceil(this.amount.aantal / parseInt(val));
      this.getData();
    },
    getData() {
      var that = this;
      let offset =
        this.pagina != 1
          ? this.pagina * this.amountToShow - this.amountToShow
          : 0;
      let asc = this.isAscending ? "A" : "D";
      this.$http
        .get(
          this.$endpoint +
            "production/approvedDHF/" +
            this.sortingOn +
            "/" +
            asc +
            "/" +
            this.amountToShow +
            "/" +
            offset
        )
        .then((response) => {
          that.amount = response.data.pop();
          that.DHRecords = response.data;

          that.DHRecords.map((r) => {
            r.dateCreated = r.dateApproved;
          });
          that.selectedDHR = null;

          switch (this.sortingOn) {
            case "ref":
              if (this.isAscending) {
                that.DHRecords.sort((a, b) => (a.DHRREF > b.DHRREF ? 1 : -1));
              } else {
                that.DHRecords.sort((a, b) => (a.DHRREF < b.DHRREF ? 1 : -1));
              }
              break;
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$store
              .dispatch("logout")
              .then(() => this.$router.push("/login"))
              .catch((err) => console.log(err));
          } else {
            that.$swal(
              "Oops that went wrong?",
              `Please contact the admin with the following info: ${error}`,
              "error"
            );
          }
        });
    },
    currentPage(page) {
      this.pagina = page; // someValue
    },
    gotSorting(sort) {
      this.isAscending = sort.asc;
      this.sortingOn = sort.on;
      this.getData();
    },
    gotDHR(dhr) {
      this.selectedDHR = dhr; // someValue
    },
    gotClick(val) {
      this.openModalHandler = !this.openModalHandler;
    },
    gotRefresh(val) {
      this.pagina = 1;
      this.amount = 0;
      this.getData();
    },
    gotRefreshPageData(val) {
      this.getData();
    },
  },
  watch: {
    pagina: function (val) {
      this.getData();
    },
    amount: function (newVal, oldVal) {
      if (
        newVal.aantal != oldVal &&
        newVal.aantal != oldVal.aantal &&
        oldVal != 0
      ) {
        this.getData();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";
/* 
.sidebar {
  background-color: red;
} */
</style>;
